import { chakra } from '@chakra-ui/react';

export const Semibold = chakra('span', {
  baseStyle: {
    fontWeight: 'semibold',
  },
});
